module.exports = __webpack_public_path__ + "img/fotos_pic.49e048cd.png";